import PageHeader from "../components/PageHeader";
import ExpertiseAngularDeveloper from "../components/Expertise-Angular-Developer";

const HireAngularJS = () => {
    return (
        <>
            <PageHeader pagetitle="Angular Js" breadcrumbMenu="Home" breadcrumbMenuActive="Angular Js" image="/images/angular-banner.svg" />
            <ExpertiseAngularDeveloper />
        </>
    )
}

export default HireAngularJS;